// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__Gze82","learnHeader":"Header_learnHeader__i2s-s"};